import React from "react";
import { Button, Modal } from "react-bootstrap";
import { AiOutlineClose } from "react-icons/ai";

const ViewLaunchedModal = ({ t, modalState, setModalState }) => {
  return (
    <div>
      {" "}
      <Modal show={true} onHide={() => setModalState({ show: false })}>
        <Modal.Header>
          <Modal.Title>{t(modalState?.data?.title)}</Modal.Title>
          <AiOutlineClose
            className="ml-auto cursor-pointer"
            size={24}
            onClick={() => setModalState({ show: false })}
          />
        </Modal.Header>
        <Modal.Body>
          {!modalState?.data?.desc ? (
            <>
              <p>
                {t(
                  "Before you proceed to create an invoice, it's important to take care of the following:"
                )}
              </p>
              <ul>
                <li>
                  <strong>{t("Update Your Bank Information:")}</strong>{" "}
                  {t(
                    "Make sure your bank details are accurately entered and up-to-date in your account."
                  )}
                  &nbsp;
                </li>
              </ul>
            </>
          ) : (
            <p>{t(modalState?.data?.desc)}</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => setModalState({ show: false })}
          >
            {t("Close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ViewLaunchedModal;
